export const getReceiveSearchDiagnostic = diagnostics => {
  if (CLIENT) {
    return diagnostics;
  }

  return {
    ...diagnostics,
    advertisementsAnalytics: null
  };
};

export const mergeDiagnostics = (stateDiagnostics, payloadDiagnostics) => {
  if (!payloadDiagnostics) {
    return stateDiagnostics;
  }

  const filteredPayload = Object.fromEntries(
    Object.entries(payloadDiagnostics).filter(
      ([, value]) => value !== null && value !== undefined
    )
  );

  return { ...stateDiagnostics, ...filteredPayload };
};
